import React from 'react';
import { initApiClient } from '@homework-studio/api-client';

import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Loading } from '@shared/ui';

//TODO: update right export and import as microservices, the current only for poc
import LoginPage from './LoginPage';

export function PublicApp() {
  React.useEffect(() => {
    initApiClient({
      baseURL: import.meta.env.VITE_BASE_URL_API,
    });
  }, []);

  return (
    <React.Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          <Route index element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    </React.Suspense>
  );
}
